import styled from "styled-components";

export const CardTitleWrapper = styled.div.attrs({
    className: 'd-flex justify-space-between'
})``
